export const PrivacyPolicyPage = () => (
    <div className="container" style={{ minHeight: "80vh", padding: "20px" }}>
      <h1>Privacy Policy</h1>
      <p>We use cookies and Google AdSense to serve relevant ads. No personal data is collected or stored by us.</p>
    </div>
  );
  